<template>
  <div class="c-callout" :class="{'is-inline': inline}">
    <div class="c-callout__content" v-html="content"></div>
  </div>
</template>

<script>
export default {
  name: 'callout',

  props: {
    content: String,
    inline: {
      type: [Boolean, String],
      default: false,
    },
  },
};
</script>

<style lang="scss">
.c-callout {
  background: $colour-nhs-blue;
  color: $colour-nhs-white;
  padding: 0.5em 1em;
  border-radius: 3px;
  margin: 3em 0;

  &__content {
    color: $colour-nhs-white;
    font-weight: 600;
    line-height: 1.666666667;
    font-size: 18px;

    a {
      color: $colour-nhs-white;
    }

    p {
      margin-bottom: 0;
    }

    p:first-of-type {
      margin: 0;
    }
  }

  &.is-inline {
    background: transparent;
    border-left: 5px solid $colour-nhs-blue;
    padding: 0 0.5em;
    border-radius: 0;
    font-family: $font-frutiger-bold;
    font-weight: bold;
  }

  &.is-inline & {
    &__content {
      font-weight: bold;
      color: $colour-nhs-black;

      a {
      color: $colour-nhs-black;
    }

    }
  }

}
</style>
